/**
 * GargaloWidget — Estacao gargalo da fabrica HOJE (TOC).
 *
 * Permissao: toc:view. Reusa /api/toc/dashboard.
 */
import React from "react";
import { Link } from "react-router-dom";

import { obterDashboardToc } from "../../../services/toc";

import { CardBody, KpiValor, KpiSub, LinkLight, CardFooter } from "../styles";


export const meta = {
  id: "gargalo",
  label: "Gargalo agora",
  descricao: "Estacao com maior tempo medio em OPs ativas (diferencial TOC).",
  categoria: "TOC",
  permissoes: ["toc:view"],
  tamanho_default: "S",
  essencial: true,
};

export async function fetchData(request) {
  return await obterDashboardToc(request, { janela: "30d" });
}

export function Widget({ dados }) {
  const g = dados?.gargalo;
  if (!g || !g.estacao) {
    return (
      <>
        <CardBody>
          <KpiValor>—</KpiValor>
          <KpiSub>Nenhuma OP ativa no momento.</KpiSub>
        </CardBody>
        <CardFooter>
          <LinkLight as={Link} to="/producao/dbr">Ver DBR</LinkLight>
        </CardFooter>
      </>
    );
  }
  return (
    <>
      <CardBody>
        <KpiValor>{g.estacao}</KpiValor>
        <KpiSub>
          {g.tempo_medio_minutos
            ? `${Math.round(g.tempo_medio_minutos)} min medios`
            : "tempo não calculado"}
          {g.fila != null && ` | ${g.fila} OPs na fila`}
        </KpiSub>
      </CardBody>
      <CardFooter>
        <LinkLight as={Link} to="/producao/dbr">Ver DBR</LinkLight>
      </CardFooter>
    </>
  );
}
